import { useState, useCallback } from 'react'
import { API, API_ROUTER } from '../../../../../api'

const useGetEvents = () => {
  const [eventsList, setEventsList] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const getEventsList = useCallback((page = 1, limit = 10, urlParams = {}) => {
    setIsLoading(true)

    API.request({
      ...API_ROUTER.events.getEvents,
      urlParams,
      pathKeys: {
        page,
        limit,
      },
    })
      .then(res => {
        setEventsList(res)
      })
      .catch(err => {
        console.error('Get events error:', err)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return {
    eventsList,
    isLoading,
    getEventsList,
  }
}

export default useGetEvents
